/**
 * ContactsSpot -- empty-state spot illustration for the contacts / prospecting
 * surface (#2580, Tier 5, EPIC #2575). A simple person-on-a-card motif: a
 * rounded card with an avatar head/shoulders line-art and one accent "add"
 * plus badge. Line-art on tokens (currentColor = muted lines, accent = brand),
 * ~160x120, aria-hidden. Agency-neutral.
 */
import SpotIllustration from "./SpotIllustration";

export function ContactsSpot({ className }: { className?: string }) {
  return (
    <SpotIllustration className={className}>
      {/* Card */}
      <rect
        x="34"
        y="24"
        width="92"
        height="72"
        rx="10"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeOpacity="0.55"
      />
      {/* Avatar head */}
      <circle cx="80" cy="52" r="11" stroke="currentColor" strokeWidth="2.5" />
      {/* Avatar shoulders */}
      <path
        d="M63 78c0-9.4 7.6-17 17-17s17 7.6 17 17"
        stroke="currentColor"
        strokeWidth="2.5"
      />
      {/* Accent "add" badge */}
      <circle cx="112" cy="34" r="9" stroke="var(--color-accent)" strokeWidth="2.5" />
      <path
        d="M112 30.5v7M108.5 34h7"
        stroke="var(--color-accent)"
        strokeWidth="2.5"
      />
    </SpotIllustration>
  );
}

export default ContactsSpot;
